<script setup>
import { computed } from "vue"
import Header from "@/js/partials/Header.vue"
import Footer from "@/js/partials/Footer.vue"
</script>

<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <Header />
    <main class="grow">
      <router-view :is-authenticated="false"></router-view>
    </main>
    <Footer />
  </div>
</template>
